import { memo, useCallback } from "react";
import type { SiteUser } from "@src/features/settings/data/mock-sites";
import { List } from "./List";
import { Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";

type CameraAdminsListProps = {
  users: SiteUser[];
  onPress?: (userId: string) => void;
};

export const CameraAdminsList = memo(({ users, onPress }: CameraAdminsListProps) => {
  const { theme } = useUnistyles();
  const renderRight = useCallback(() => {
    return <Icon name="chevronRight" color={theme.colors.textSecondary} />;
  }, [theme]);
  if (users.length === 0) {
    return (
      <Text textStyle="sm/regular" color="textMuted" textAlign="center">
        No admins found
      </Text>
    );
  }
  return <List items={users} onItemPress={onPress} renderRight={renderRight} />;
});
